/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanionSessionEntity
 */
export interface CompanionSessionEntity {
    /**
     * セッション名（用途識別子）
     * @type {string}
     * @memberof CompanionSessionEntity
     */
    sessionName: string;
    /**
     * 発行された companion セッションのアクセストークン
     * @type {string}
     * @memberof CompanionSessionEntity
     */
    accessToken: string;
    /**
     * 発行された companion セッションのリフレッシュトークン。
     * 呼び出し元がサーバー間で安全に保管すること（acomo は再取得手段を提供しない）。
     * @type {string}
     * @memberof CompanionSessionEntity
     */
    refreshToken: string;
}

/**
 * Check if a given object implements the CompanionSessionEntity interface.
 */
export function instanceOfCompanionSessionEntity(value: object): value is CompanionSessionEntity {
    if (!('sessionName' in value) || value['sessionName'] === undefined) return false;
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    return true;
}

export function CompanionSessionEntityFromJSON(json: any): CompanionSessionEntity {
    return CompanionSessionEntityFromJSONTyped(json, false);
}

export function CompanionSessionEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanionSessionEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionName': json['sessionName'],
        'accessToken': json['accessToken'],
        'refreshToken': json['refreshToken'],
    };
}

export function CompanionSessionEntityToJSON(json: any): CompanionSessionEntity {
    return CompanionSessionEntityToJSONTyped(json, false);
}

export function CompanionSessionEntityToJSONTyped(value?: CompanionSessionEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionName': value['sessionName'],
        'accessToken': value['accessToken'],
        'refreshToken': value['refreshToken'],
    };
}

